import fixDate from "@/common/fix-date";
import ITripPayment from "@/models/trip-payments/itrip-payment";
import { get, post, put, remove } from "./base-service";

const baseUrl = "trippayments";

export async function getTripPayments(tripId: number): Promise<ITripPayment[]> {

    const response = await get(`${baseUrl}/trip`, tripId);

    return response.json();
}

export async function getTripPayment(id: number): Promise<ITripPayment> {

    const response = await get(baseUrl, id);

    return response.json();
}

export async function addTripPayment(tripPayment: ITripPayment): Promise<boolean> {

    const newTripPayment = {
        ...tripPayment,
        paymentDate: fixDate(tripPayment.paymentDate)
    };

    const response = await post(baseUrl, newTripPayment);

    return response.ok;
}

export async function updateTripPayment(tripPayment: ITripPayment): Promise<boolean> {

    const newTripPayment = {
        ...tripPayment,
        paymentDate: fixDate(tripPayment.paymentDate)
    };

    const response = await put(baseUrl, newTripPayment);

    return response.ok;
}

export async function deleteTripPayment(id: number): Promise<boolean> {
    
    const response = await remove(baseUrl, id);

    return response.ok;
}

export async function getTripsWithMissingPaymentsForRetreat(retreatId: string): Promise<number[]> {

    const response = await get(`${baseUrl}/retreat/missing-payments`, retreatId);

    return response.json();
}